import { ILieuucation } from '@lieuu/core';

export default (): ILieuucation => ({
  _id: '5e20bb5425840d5e99237711',
  internalIds: ['MDQwMTMyMTY4MTMy'],
  centLon: -111.9167801,
  centLat: 33.569857,
  version: '4.0.2',
  name: 'Report',

  cbsa: 'Phoenix-Mesa-Scottsdale, AZ',

  featureCollection: {
    type: 'FeatureCollection',
    features: [
      {
        properties: {
          centLat: 33.569857,
          centLon: -111.9167801,
          id: '5e20bb5425840d5e99237711',
          name: 'Report',
          version: '4.0.2',
          internalId: 'MDQwMTMyMTY4MTMy',
          type: 'lieuucation',
          state: 'Arizona',
          cbsa: 'Phoenix-Mesa-Scottsdale, AZ',
          zip: '85258',
          'marketProfile:walkability': -1,
          'marketProfile:jobsWithin45': -1,
          'marketProfile:population:trendPercent:oneYr': 0.021437578814627933,
          'marketProfile:population:trendPercent:fiveYr': -0.04368358913813464,
          'marketProfile:population:trendPercent:sevenYr': -0.009779951100244544,
          'marketProfile:income:household:latest': 74063,
          'marketProfile:income:household:trendCagr:oneYr': -0.10517349700367296,
          'marketProfile:income:household:trendCagr:fiveYrCagr': -0.11614486044738792,
          'marketProfile:income:household:trendCagr:sevenYrCagr': -0.07934390026341509,
          'marketProfile:typicalAge:latest': 70.7,
          'marketProfile:typicalAge:trendPercent:oneYr': 0.007122507122507171,
          'marketProfile:typicalAge:trendPercent:fiveYr': 0.07446808510638303,
          'marketProfile:typicalAge:trendPercent:sevenYr': 0.10641627543035992,
          'marketProfile:bachelorsOrHigher': 0.7946127946127947,
          'housing:areaLand': 1701101,
          'housing:areaWater': 0,
          'housing:monthlyOwnerCostsPercentIncome:latest': 5536,
          'housing:grossRent:latest': 1821,
          'housing:grossRent:trendCagr:oneYr': -0.12578012481997125,
          'housing:grossRent:trendCagr:fiveYrCagr': -0.0186756587493786,
          'housing:grossRent:trendCagr:sevenYrCagr': -0.011100783486536425,
          'housing:homeValue:latest': 553600,
          'housing:homeValue:trendCagr:oneYr': 0.15333333333333332,
          'housing:homeValue:trendCagr:fiveYrCagr': -0.03111860805005895,
          'housing:homeValue:trendCagr:sevenYrCagr': -0.017763284525754153,
          'housing:tenure:renter:trendPercent:oneYr': -0.1013766361311953,
          'housing:tenure:renter:trendPercent:fiveYr': 0.41573249222113295,
          'housing:tenure:renter:trendPercent:sevenYr': 0.4116879549512431,
          'safety:crimes:violent:totalCount': -1,
          'safety:crimes:nonViolent:totalCount': -1,
          'schools:assignedSchoolsRating:overall': 0.9,
          'shortTermRentals:airbnb:nightly:roomRate': 99,
          'shortTermRentals:airbnb:nightly:wholeHomeRate': 240.66666666666666
        },
        type: 'Feature',
        geometry: {
          coordinates: [
            [
              [-111.92604400012998, 33.57496500005488],
              [-111.92604300030506, 33.574774000177946],
              [-111.92602999988625, 33.57304300017689],
              [-111.92597999965754, 33.57026700014585],
              [-111.92595600026641, 33.56932899969931],
              [-111.92594500039577, 33.56859399999242],
              [-111.92594000037289, 33.56745899971227],
              [-111.92582499984685, 33.567444000357185],
              [-111.92563400005113, 33.56743800031499],
              [-111.92551199985239, 33.56743800031499],
              [-111.92470400028863, 33.56746199973265],
              [-111.92442700027921, 33.56745799970541],
              [-111.92418799990462, 33.567444000357185],
              [-111.92384800014598, 33.5674080000979],
              [-111.92352500010578, 33.567355999696915],
              [-111.9232599997919, 33.567296999952546],
              [-111.92299700002619, 33.567224000035395],
              [-111.92183000043721, 33.56676799972004],
              [-111.92135800043411, 33.566503999894415],
              [-111.92067100034586, 33.5660780002089],
              [-111.91961400036173, 33.565416999815056],
              [-111.9195139999043, 33.5653600003051],
              [-111.91900199971823, 33.56512100001981],
              [-111.91867000035552, 33.56498999997112],
              [-111.91833100042182, 33.56487400027636],
              [-111.9179849999171, 33.56477200020954],
              [-111.91767000027282, 33.56469500024808],
              [-111.9174159998296, 33.56464599982856],
              [-111.9173809996695, 33.564640999631436],
              [-111.91724900032334, 33.56462000029734],
              [-111.9162540002635, 33.56450800026962],
              [-111.91596399983527, 33.56447499965901],
              [-111.91511699991345, 33.56437099978427],
              [-111.9149579999048, 33.564350999678815],
              [-111.91462499981886, 33.56431000015934],
              [-111.91417799993012, 33.564246999654756],
              [-111.91382300010287, 33.564176000242924],
              [-111.91347199957528, 33.564094000269726],
              [-111.91334100005402, 33.56406100024945],
              [-111.9132049996116, 33.5640169997037],
              [-111.9129450002189, 33.56392699994664],
              [-111.91259399969132, 33.56379000003658],
              [-111.912283000245, 33.56365099980737],
              [-111.91197299972531, 33.56350299962969],
              [-111.91169499989095, 33.56334999967504],
              [-111.91144499964568, 33.563191999916846],
              [-111.91124600035238, 33.56305000004857],
              [-111.91079600009057, 33.56268100035872],
              [-111.91066300002119, 33.56257200025216],
              [-111.91015300038325, 33.56295300036804],
              [-111.90972200038804, 33.56329899987944],
              [-111.909614000433, 33.563416000246484],
              [-111.90944100018064, 33.563632999637434],
              [-111.9093340000505, 33.56378499978992],
              [-111.9092920002177, 33.56384100029076],
              [-111.90919900033131, 33.563990999983105],
              [-111.90911700031553, 33.56414799973138],
              [-111.90904199997246, 33.56432199992939],
              [-111.90898599989596, 33.56448700015474],
              [-111.90893599966725, 33.56468399982025],
              [-111.90890499970511, 33.56487799967476],
              [-111.90889800003242, 33.56495400018578],
              [-111.9088960003826, 33.56505099986425],
              [-111.90888799998667, 33.565429000179876],
              [-111.90888399978871, 33.56674600013968],
              [-111.90887899976583, 33.567186999674455],
              [-111.90888499961363, 33.56886600008884],
              [-111.9088829999638, 33.56939700016047],
              [-111.90888399978871, 33.56994199965428],
              [-111.90888499961363, 33.57080900023155],
              [-111.90888600033685, 33.571894999835884],
              [-111.90889800003242, 33.572424000090805],
              [-111.90889200018464, 33.573092000321765],
              [-111.90889499965937, 33.573935000093776],
              [-111.90889999968223, 33.57395899995075],
              [-111.90892700034473, 33.57405300019961],
              [-111.90896499997957, 33.574134999696184],
              [-111.90901299966013, 33.574208999686086],
              [-111.90907399975951, 33.574280999757],
              [-111.90914599972955, 33.57434500035175],
              [-111.9092129996767, 33.57439299983108],
              [-111.90922600009547, 33.57440000006478],
              [-111.90930899993616, 33.5744470003361],
              [-111.90943000030998, 33.574492999908095],
              [-111.90953999991483, 33.57452000013352],
              [-111.90980600005363, 33.57453000013175],
              [-111.91022500035326, 33.57453800027915],
              [-111.91084899979403, 33.57453900020399],
              [-111.91143399977504, 33.57454000012878],
              [-111.91230900018428, 33.57454599967739],
              [-111.91254699983564, 33.57454800027529],
              [-111.91263100039954, 33.57455100004935],
              [-111.91250699965268, 33.574840000249786],
              [-111.91274299965423, 33.57484200009243],
              [-111.91304499977802, 33.57484499985632],
              [-111.91702500001735, 33.57485599973796],
              [-111.91736899997395, 33.57485699965913],
              [-111.91986999955647, 33.574869000208736],
              [-111.92132300027401, 33.57487900016648],
              [-111.92144600029765, 33.57487800024562],
              [-111.92170800023847, 33.57487599965537],
              [-111.92312699972253, 33.57488600036077],
              [-111.92390900024536, 33.574910999873865],
              [-111.92495899965844, 33.57496999965411],
              [-111.92545400012608, 33.574975000001515],
              [-111.92604400012998, 33.57496500005488]
            ]
          ],

          type: 'Polygon'
        }
      }
    ]
  },
  properties: {
    version: '4.0.2',
    housing: {
      areaLand: 1701101,
      areaWater: 0,
      homeValue: {
        latest: 553600,
        trend: {
          '2009': 603300,
          '2010': 630000,
          '2011': 627600,
          '2012': 616600,
          '2013': 648400,
          '2014': 597500,
          '2015': 551400,
          '2016': 543700,
          '2017': 480000,
          '2018': 553600
        },
        trendCagr: {
          oneYr: 0.15333333333333332,
          fiveYrCagr: -0.03111860805005895,
          sevenYrCagr: -0.017763284525754153,
          tenYrCagr: -0.009506984711898814
        }
      },
      monthlyOwnerCostsPercentIncome: {
        latest: 5536,
        trend: {
          '2009': 6033,
          '2010': 6300,
          '2011': 6276,
          '2012': 6166,
          '2013': 6484,
          '2014': 5975,
          '2015': 5514,
          '2016': 5437,
          '2017': 4800,
          '2018': 5536
        },
        trendPercent: {
          oneYr: 0.15333333333333332,
          fiveYr: -0.14620604565083284,
          sevenYr: -0.11790949649458249,
          tenYr: -0.08238024200232053
        }
      },
      grossRent: {
        latest: 1821,
        trend: {
          '2009': 1766,
          '2010': 1855,
          '2011': 1969,
          '2012': 1781,
          '2013': 2001,
          '2014': -1,
          '2015': 2286,
          '2016': 2286,
          '2017': 2083,
          '2018': 1821
        },
        trendCagr: {
          oneYr: -0.12578012481997125,
          fiveYrCagr: -0.0186756587493786,
          sevenYrCagr: -0.011100783486536425,
          tenYrCagr: 0.003413445756175859
        }
      },
      electricHeating: 0.90234375,
      solarHeating: 0,
      gasHeating: 0.09765625,
      mortgageStatus: {
        none: 0.6895787139689579,
        mortgage: 0.2682926829268293,
        helocOrSecondMortgage: 0.04212860310421286
      },
      householdType: {
        family: {
          latest: 0.546875,
          trend: {
            '2009': -1,
            '2010': 0.47232472324723246,
            '2011': 0.3973384030418251,
            '2012': 0.3920792079207921,
            '2013': 0.395910780669145,
            '2014': 0.4279918864097363,
            '2015': 0.515625,
            '2016': 0.5319148936170213,
            '2017': 0.5714285714285714,
            '2018': 0.546875
          },
          trendPercent: {
            oneYr: -0.04296875,
            fiveYr: 0.3813086854460095,
            sevenYr: 0.37634569377990434,
            tenYr: -1
          }
        },
        singleHouseholds: 0.453125,
        twoPersonHouseholds: 0.513671875,
        twoOrMoreHouseholds: 0.033203125
      },
      tenure: {
        owner: {
          latest: 0.5574783683559951,
          trend: {
            '2009': -1,
            '2010': 0.46594274432379074,
            '2011': 0.466864490603363,
            '2012': 0.43531633616619453,
            '2013': 0.44077134986225897,
            '2014': 0.42246982358402974,
            '2015': 0.39960435212660733,
            '2016': 0.4423076923076923,
            '2017': 0.48735632183908045,
            '2018': 0.5574783683559951
          },
          trendPercent: {
            oneYr: 0.1438825011078202,
            fiveYr: 0.26477904820766374,
            sevenYr: 0.1940903186608285,
            tenYr: -1
          }
        },
        renter: {
          latest: 0.0754017305315204,
          trend: {
            '2009': -1,
            '2010': 0.06910167818361303,
            '2011': 0.05341246290801187,
            '2012': 0.04154863078375826,
            '2013': 0.05325987144168962,
            '2014': 0.035283194057567316,
            '2015': 0.043521266073194856,
            '2016': 0.05982905982905983,
            '2017': 0.0839080459770115,
            '2018': 0.0754017305315204
          },
          trendPercent: {
            oneYr: -0.1013766361311953,
            fiveYr: 0.41573249222113295,
            sevenYr: 0.4116879549512431,
            tenYr: -1
          }
        },
        vacant: {
          latest: 0.36711990111248455,
          trend: {
            '2009': -1,
            '2010': 0.46495557749259625,
            '2011': 0.4797230464886251,
            '2012': 0.5231350330500472,
            '2013': 0.5059687786960514,
            '2014': 0.542246982358403,
            '2015': 0.5568743818001978,
            '2016': 0.49786324786324787,
            '2017': 0.42873563218390803,
            '2018': 0.36711990111248455
          },
          trendPercent: {
            oneYr: -0.14371497595747573,
            fiveYr: -0.27442182883576094,
            sevenYr: -0.23472531953665587,
            tenYr: -1
          }
        }
      },
      homesBuiltOnOrAfter2000: 0.07416563658838071,
      homesBuiltBefore2000: 0.9258343634116193,
      bedrooms: {
        overall: {
          studio: 0,
          one: 0.016069221260815822,
          two: 0.5550061804697157,
          three: 0.38813349814585907,
          four: 0.0407911001236094,
          fiveOrMore: 0
        },
        rented: {
          studio: 0,
          one: 0.025390625,
          two: 0.060546875,
          three: 0,
          four: 0.033203125,
          fiveOrMore: 0
        },
        owner: {
          studio: 0,
          one: 0,
          two: 0.51953125,
          three: 0.330078125,
          four: 0.03125,
          fiveOrMore: 0
        }
      }
    },
    marketProfile: {
      population: {
        latest: 810,
        trend: {
          '2009': -1,
          '2010': 883,
          '2011': 818,
          '2012': 768,
          '2013': 847,
          '2014': 782,
          '2015': 675,
          '2016': 722,
          '2017': 793,
          '2018': 810
        },
        trendPercent: {
          oneYr: 0.021437578814627933,
          fiveYr: -0.04368358913813464,
          sevenYr: -0.009779951100244544,
          tenYr: -1
        }
      },
      male: 0.36666666666666664,
      female: 0.6333333333333333,
      typicalAge: {
        latest: 70.7,
        trend: {
          '2009': 61.8,
          '2010': 63,
          '2011': 63.9,
          '2012': 68.3,
          '2013': 65.8,
          '2014': 64.7,
          '2015': 69.7,
          '2016': 69.4,
          '2017': 70.2,
          '2018': 70.7
        },
        trendPercent: {
          oneYr: 0.007122507122507171,
          fiveYr: 0.07446808510638303,
          sevenYr: 0.10641627543035992,
          tenYr: 0.14401294498381878
        }
      },
      homeComputers: 0.966796875,
      smartphone: 0.7421875,
      bachelorsOrHigher: 0.7946127946127947,
      homeInternet: 0.966796875,
      walkability: -1,
      jobsPerAcre: -1,
      jobsWithin45: -1,
      income: {
        household: {
          latest: 74063,
          trend: {
            '2009': 104688,
            '2010': 128864,
            '2011': 132105,
            '2012': 122946,
            '2013': 137308,
            '2014': 120865,
            '2015': 81250,
            '2016': 86000,
            '2017': 82768,
            '2018': 74063
          },
          trendCagr: {
            oneYr: -0.10517349700367296,
            fiveYrCagr: -0.11614486044738792,
            sevenYrCagr: -0.07934390026341509,
            tenYrCagr: -0.03772215148343461
          }
        },
        socialSecurity: 0.55078125,
        retirementIncome: 0.091796875,
        selfEmploymentIncome: 0.064453125
      },
      schoolEnrollment: {
        overall: 0.020987654320987655,
        gradSchool: 0,
        undergraduate: 0,
        highSchool: 0,
        middleSchool: 0,
        gradeSchool: 0.020987654320987655,
        preSchool: 0
      },
      workTransport: {
        carpool: 0,
        car: 0.7715231788079471,
        motorcycle: 0,
        walk: 0,
        bike: 0,
        taxi: 0,
        workAtHome: 0.17218543046357615,
        other: 0,
        public: {
          overall: 0.056291390728476824,
          bus: 0,
          subway: 0.056291390728476824,
          other: 0
        }
      },
      degreeField: {
        stem: 0.44370860927152317,
        business: 0.38741721854304634,
        education: 0.31456953642384106,
        artsAndHumanities: 0.5033112582781457
      }
    },
    shortTermRentals: {
      airbnb: {
        percentInstantBook: 0.5,
        listings: [],
        nightly: {
          wholeHomeRate: 240.66666666666666,
          roomRate: 99
        },
        weekly: {
          wholeHomeRate: 1651.069359333333,
          roomRate: 658.35
        },
        monthly: {
          wholeHomeRate: 6886.769230769231,
          roomRate: 2673
        }
      }
    },
    schools: {
      allSchoolsRating: {
        overall: 0.9550000000000001,
        belowHighSchool: 0.9631578947368421,
        highSchool: 0.8
      },
      assignedSchoolsRating: {
        overall: 0.9,
        belowHighSchool: 0.95,
        highSchool: 0.8
      },
      privateSchoolsRating: {
        overall: 1,
        belowHighSchool: 1,
        highSchool: -1
      }
    },
    safety: {
      crimes: {
        violent: {
          totalCount: 2,
          crimes: []
        },
        nonViolent: {
          totalCount: 1,
          crimes: []
        }
      }
    },
    internalIds: ['MDQwMTMyMTY4MTMy'],
    type: 'lieuucation',
    name: 'Report',
    id: '5e20bb5425840d5e99237711'
  },
  county: '013',
  state: 'Arizona',
  zip: '85258',
  lieuucationState: undefined,
  lieuucationCbsa: {
    _id: '5e21102b03517e080971080b',
    version: '4.0.2',
    name: 'Phoenix-Mesa-Scottsdale, AZ',
    internalId: 'MzgwNjA=',
    featureCollection: {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            coordinates: [
              [
                [-112.20362399964132, 32.506721000059336],
                [-112.20112200023388, 32.50672600005293],
                [-112.19361799986477, 32.506747000022834],
                [-112.19111700028226, 32.506755000010095],
                [-112.19022400032968, 32.50675400001168],
                [-112.18754499957362, 32.50675300001332],
                [-112.18665199962103, 32.50675300001332],
                [-112.1848530001954, 32.50675200001493],
                [-112.17945699994674, 32.50674900001972],
                [-112.21607999984504, 32.50672500005424],
                [-112.216015000446, 32.50672500005424],
                [-112.20948299967223, 32.50672300005679],
                [-112.2093830001131, 32.50672200005807],
                [-112.20908299963914, 32.50672300005679],
                [-112.20898399990494, 32.50672300005679],
                [-112.20791199985223, 32.506721000059336],
                [-112.20469599969404, 32.506720000060604],
                [-112.20362399964132, 32.506721000059336]
              ]
            ],

            type: 'Polygon'
          },
          properties: {
            centLat: 33.569857,
            centLon: -111.9167801,
            id: '5e20bb5425840d5e99237711',
            name: 'Report',
            version: '4.0.2',
            internalId: 'MDQwMTMyMTY4MTMy',
            type: 'cbsa',
            state: 'Arizona',
            cbsa: 'Phoenix-Mesa-Scottsdale, AZ',
            zip: '85258',
            'marketProfile:walkability': -1,
            'marketProfile:jobsWithin45': -1,
            'marketProfile:population:trendPercent:oneYr': 0.021437578814627933,
            'marketProfile:population:trendPercent:fiveYr': -0.04368358913813464,
            'marketProfile:population:trendPercent:sevenYr': -0.009779951100244544,
            'marketProfile:income:household:latest': 74063,
            'marketProfile:income:household:trendCagr:oneYr': -0.10517349700367296,
            'marketProfile:income:household:trendCagr:fiveYrCagr': -0.11614486044738792,
            'marketProfile:income:household:trendCagr:sevenYrCagr': -0.07934390026341509,
            'marketProfile:typicalAge:latest': 70.7,
            'marketProfile:typicalAge:trendPercent:oneYr': 0.007122507122507171,
            'marketProfile:typicalAge:trendPercent:fiveYr': 0.07446808510638303,
            'marketProfile:typicalAge:trendPercent:sevenYr': 0.10641627543035992,
            'marketProfile:bachelorsOrHigher': 0.7946127946127947,
            'housing:areaLand': 1701101,
            'housing:areaWater': 0,
            'housing:monthlyOwnerCostsPercentIncome:latest': 5536,
            'housing:grossRent:latest': 1821,
            'housing:grossRent:trendCagr:oneYr': -0.12578012481997125,
            'housing:grossRent:trendCagr:fiveYrCagr': -0.0186756587493786,
            'housing:grossRent:trendCagr:sevenYrCagr': -0.011100783486536425,
            'housing:homeValue:latest': 553600,
            'housing:homeValue:trendCagr:oneYr': 0.15333333333333332,
            'housing:homeValue:trendCagr:fiveYrCagr': -0.03111860805005895,
            'housing:homeValue:trendCagr:sevenYrCagr': -0.017763284525754153,
            'housing:tenure:renter:trendPercent:oneYr': -0.1013766361311953,
            'housing:tenure:renter:trendPercent:fiveYr': 0.41573249222113295,
            'housing:tenure:renter:trendPercent:sevenYr': 0.4116879549512431,
            'safety:crimes:violent:totalCount': -1,
            'safety:crimes:nonViolent:totalCount': -1,
            'schools:assignedSchoolsRating:overall': 0.9,
            'shortTermRentals:airbnb:nightly:roomRate': 99,
            'shortTermRentals:airbnb:nightly:wholeHomeRate': 240.66666666666666
          }
        }
      ]
    },
    lieuucationState: '5e210f96b6c4a002eb7ceb35',
    properties: {
      version: '4.0.2',
      safety: {
        crimes: {
          violent: {
            totalCount: 1.6475803472478758,
            crimes: []
          },
          nonViolent: {
            totalCount: 6.96970816401921,
            crimes: []
          }
        }
      },
      housing: {
        areaLand: 790010,
        areaWater: 0,
        homeValue: {
          latest: 213350,
          trend: {
            '2009': 204550,
            '2010': 215700,
            '2011': 189300,
            '2012': 164600,
            '2013': 154000,
            '2014': 153000,
            '2015': 157900,
            '2016': 174100,
            '2017': 193300,
            '2018': 213350
          },
          trendCagr: {
            oneYr: 0.10372478013450603,
            fiveYrCagr: 0.06736850845680298,
            sevenYrCagr: 0.017232648205731893,
            tenYrCagr: 0.004691143037358403
          }
        },
        monthlyOwnerCostsPercentIncome: {
          latest: 2133.5,
          trend: {
            '2009': 2045.5,
            '2010': 2157,
            '2011': 1893,
            '2012': 1646,
            '2013': 1540,
            '2014': 1530,
            '2015': 1579,
            '2016': 1741,
            '2017': 1933,
            '2018': 2133.5
          },
          trendPercent: {
            oneYr: 0.10372478013450603,
            fiveYr: 0.3853896103896104,
            sevenYr: 0.1270470153195986,
            tenYr: 0.04302126619408453
          }
        },
        grossRent: {
          latest: 1156,
          trend: {
            '2009': 918,
            '2010': 1007,
            '2011': 1044,
            '2012': 1052,
            '2013': 1037.5,
            '2014': 1055,
            '2015': 1056,
            '2016': 1091.5,
            '2017': 1118,
            '2018': 1156
          },
          trendCagr: {
            oneYr: 0.03398926654740597,
            fiveYrCagr: 0.02186599151876467,
            sevenYrCagr: 0.014664524485879848,
            tenYrCagr: 0.02594459041397168
          }
        },
        electricHeating: 0.7621252298875155,
        solarHeating: 0,
        gasHeating: 0.20571810291829662,
        mortgageStatus: {
          none: 0.2845659163987138,
          mortgage: 0.616,
          helocOrSecondMortgage: 0.06559139784946237
        },
        householdType: {
          family: {
            latest: 0.6931483743528633,
            trend: {
              '2009': -1,
              '2010': 0.7055393586005831,
              '2011': 0.7049180327868853,
              '2012': 0.702922077922078,
              '2013': 0.7043010752688172,
              '2014': 0.6980762116167221,
              '2015': 0.6959459459459459,
              '2016': 0.69558599695586,
              '2017': 0.6896551724137931,
              '2018': 0.6931483743528633
            },
            trendPercent: {
              oneYr: 0.005065142811651713,
              fiveYr: -0.015835132598224777,
              sevenYr: -0.01669649219710101,
              tenYr: -1
            }
          },
          singleHouseholds: 0.23817241645442616,
          twoPersonHouseholds: 0.32528910280322815,
          twoOrMoreHouseholds: 0.404421100809071
        },
        tenure: {
          owner: {
            latest: 0.6105592919033827,
            trend: {
              '2009': -1,
              '2010': 0.6490373424666644,
              '2011': 0.6282051282051282,
              '2012': 0.6094674556213018,
              '2013': 0.5979381443298969,
              '2014': 0.5885118416401556,
              '2015': 0.5867875647668394,
              '2016': 0.5873983739837398,
              '2017': 0.5945072697899838,
              '2018': 0.6105592919033827
            },
            trendPercent: {
              oneYr: 0.027000548065744256,
              fiveYr: 0.021107781286691774,
              sevenYr: -0.02808929043951336,
              tenYr: -1
            }
          },
          renter: {
            latest: 0.280127232459547,
            trend: {
              '2009': -1,
              '2010': 0.21738611989162338,
              '2011': 0.23219814241486067,
              '2012': 0.24444444444444444,
              '2013': 0.2594202898550725,
              '2014': 0.2696960092966748,
              '2015': 0.27569331158238175,
              '2016': 0.28458049886621317,
              '2017': 0.28094302554027506,
              '2018': 0.280127232459547
            },
            trendPercent: {
              oneYr: -0.002903766979654332,
              fiveYr: 0.07982005808428738,
              sevenYr: 0.2064146144591159,
              tenYr: -1
            }
          },
          vacant: {
            latest: 0.09108535688005887,
            trend: {
              '2009': -1,
              '2010': 0.1111820634859071,
              '2011': 0.11774744027303755,
              '2012': 0.12222222222222222,
              '2013': 0.11954992967651196,
              '2014': 0.11811023622047244,
              '2015': 0.11311053984575835,
              '2016': 0.10369068541300527,
              '2017': 0.09719626168224299,
              '2018': 0.09108535688005887
            },
            trendPercent: {
              oneYr: -0.06287180902247125,
              fiveYr: -0.23809777950915467,
              sevenYr: -0.22643450533747111,
              tenYr: -1
            }
          }
        },
        homesBuiltOnOrAfter2000: 0.11216621662166217,
        homesBuiltBefore2000: 0.8878337833783378,
        bedrooms: {
          overall: {
            studio: 0,
            one: 0.026174620791712913,
            two: 0.2019353940406572,
            three: 0.3669694254371674,
            four: 0.18257848453091538,
            fiveOrMore: 0.017180799087997394
          },
          rented: {
            studio: 0,
            one: 0,
            two: 0.06591294037940379,
            three: 0.08116945507785692,
            four: 0.019591954237459817,
            fiveOrMore: 0
          },
          owner: {
            studio: 0,
            one: 0,
            two: 0.05683139216073348,
            three: 0.26867577182499547,
            four: 0.14355734140849447,
            fiveOrMore: 0.011495862307668104
          }
        }
      },
      schools: {
        allSchoolsRating: {
          overall: 0.7789478213821928,
          belowHighSchool: 0.7897245452237196,
          highSchool: 0.6972571913908617
        },
        assignedSchoolsRating: {
          overall: 0.5664782007789909,
          belowHighSchool: 0.572117152613607,
          highSchool: 0.5574608408903501
        },
        privateSchoolsRating: {
          overall: 0.8482495256671307,
          belowHighSchool: 0.8526697444538008,
          highSchool: 0.7883750372356237
        }
      },
      shortTermRentals: {
        airbnb: {
          percentInstantBook: 0.5574011863946023,
          listings: [],
          nightly: {
            wholeHomeRate: 172.68265339306456,
            roomRate: 62.62542674128042
          },
          weekly: {
            wholeHomeRate: 1152.245185690932,
            roomRate: 412.5176583919448
          },
          monthly: {
            wholeHomeRate: 4730.442592950102,
            roomRate: 1708.6420439446397
          }
        }
      },
      marketProfile: {
        population: {
          latest: 1559,
          trend: {
            '2009': -1,
            '2010': 1434,
            '2011': 1455,
            '2012': 1467,
            '2013': 1472,
            '2014': 1493,
            '2015': 1494,
            '2016': 1521,
            '2017': 1531,
            '2018': 1559
          },
          trendPercent: {
            oneYr: 0.018288700195950414,
            fiveYr: 0.05910326086956519,
            sevenYr: 0.07147766323024052,
            tenYr: -1
          }
        },
        male: 0.49249859143097574,
        female: 0.5075014085690243,
        typicalAge: {
          latest: 36.1,
          trend: {
            '2009': 33.4,
            '2010': 34.3,
            '2011': 34.6,
            '2012': 34.6,
            '2013': 35.1,
            '2014': 35.4,
            '2015': 35.6,
            '2016': 35.8,
            '2017': 36,
            '2018': 36.1
          },
          trendPercent: {
            oneYr: 0.002777777777777768,
            fiveYr: 0.028490028490028463,
            sevenYr: 0.043352601156069426,
            tenYr: 0.08083832335329344
          }
        },
        homeComputers: 0.9416865754884252,
        smartphone: 0.8165572807147965,
        bachelorsOrHigher: 0.27115384615384613,
        homeInternet: 0.9083888744089064,
        walkability: 7.833,
        jobsPerAcre: 0.46395393404850005,
        jobsWithin45: 162156.2351,
        income: {
          household: {
            latest: 60959.5,
            trend: {
              '2009': 49922,
              '2010': 54755.5,
              '2011': 54745,
              '2012': 53488.5,
              '2013': 53162,
              '2014': 53000,
              '2015': 52887.5,
              '2016': 55281.5,
              '2017': 57639,
              '2018': 60959.5
            },
            trendCagr: {
              oneYr: 0.05760856364614231,
              fiveYrCagr: 0.027751257937177254,
              sevenYrCagr: 0.01547910335052105,
              tenYrCagr: 0.022442337337472917
            }
          },
          socialSecurity: 0.253387314439946,
          retirementIncome: 0.15308962076952493,
          selfEmploymentIncome: 0.09835930204582619
        },
        schoolEnrollment: {
          overall: 0.2589884540739214,
          gradSchool: 0.007125890736342043,
          undergraduate: 0.0443633965431267,
          highSchool: 0.05192087695191058,
          middleSchool: 0.05043189368770764,
          gradeSchool: 0.04958660038606741,
          preSchool: 0.021100371021284904
        },
        workTransport: {
          carpool: 0.09573241061130335,
          car: 0.8851913477537438,
          motorcycle: 0,
          walk: 0,
          bike: 0,
          taxi: 0,
          workAtHome: 0.05182072829131653,
          other: 0,
          public: {
            overall: 0,
            bus: 0,
            subway: 0,
            other: 0
          }
        },
        degreeField: {
          stem: 0.15798922800718132,
          business: 0.08208955223880597,
          education: 0.049494949494949494,
          artsAndHumanities: 0.08282828282828283
        }
      },
      type: 'cbsa',
      name: 'Phoenix-Mesa-Scottsdale, AZ',
      internalId: 'MzgwNjA=',
      id: '5e21102b03517e080971080b'
    },
    lieuucationCountry: '5e2114cde2731a1c623892dd'
  },
  lieuucationZip: undefined,
  lieuucationCountry: undefined
});
